import type { ArticleData, ProgrammeData } from './types';

export const pageSize = 20;

export const filters = {
    programmes: {
        level: {
            name: 'Level',
            options: ['Bachelor', 'Master', 'PhD', 'OneYearProgrammes'],
            MasterCourses: 'MasterCourses',
            BachelorCourses: 'BachelorCourses',
        },
        load: {
            name: 'Load',
            options: ['FullTime', 'PartTime'] satisfies ProgrammeData['loads'],
        },
        semester: {
            name: 'Semester',
            options: ['Fall', 'Spring'] as const,
        },
        language: {
            name: 'ProgrammeLanguage',
            options: ['English', 'Norwegian'] satisfies ProgrammeData['programmeLanguage'][],
        },
        campus: {
            name: 'Campus',
            options: ['Oslo', 'Bergen', 'Stavanger', 'Trondheim', 'Online'],
        },
        academicField: {
            name: 'AcademicField',
            options: [
                'DigitalisationAndAnalytics',
                'RealEstateRetailAndBusinessLaw',
                'FinanceEconomicsAndGovernance',
                'InternationalBusiness',
                'Management',
                'MarketingCommunicationAndCulture',
                'PublicSector',
                'OrganisationalDevelopmentAndHumanResourceManagement',
                'ProjectManagement',
                'StrategyInnovationAndSustainability',
            ],
        },
    },
    articles: {
        type: {
            name: 'ArticleType',
            options: ['BiBusinessReview', 'News', 'Other'] satisfies ArticleData['type'][],
        },
        year: {
            name: 'Year',
        },
    },
    employees: {
        campus: {
            name: 'Campus',
            options: ['Oslo', 'Bergen', 'Stavanger', 'Trondheim'],
        },
    },
    events: {
        type: {
            name: 'EventType',
            options: [
                'alumni-partner',
                'alumni-conference',
                'research',
                'Executive',
                'executive-webinar',
                'bi-startup',
                'leaders-toolbox',
                'sustainability',
                'bachelor',
                'master',
                'phd',
            ],
        },
        campus: {
            name: 'Campus',
            options: ['Oslo', 'Bergen', 'Stavanger', 'Trondheim'],
        },
    },
} as const;

export const formatDate = (date: Date, language: string) => {
    return new Intl.DateTimeFormat(language === 'en' ? 'en-GB' : language, {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
    }).format(date);
};

export const formatDateRange = (from: Date, to: Date, language: string) => {
    const isSameDay = from.toDateString() === to.toDateString();
    const format = new Intl.DateTimeFormat(language === 'en' ? 'en-GB' : language, {
        weekday: isSameDay ? 'long' : undefined,
        year: from.getFullYear() === to.getFullYear() ? undefined : 'numeric',
        month: isSameDay ? 'long' : 'short',
        day: 'numeric',
        hour: 'numeric',
        minute: 'numeric',
        hourCycle: 'h24',
    }).formatRange(from, to);
    return format[0].toUpperCase() + format.slice(1);
};

export const formatPhoneNumber = (phone: string) => {
    if (phone.startsWith('+') && phone.length === 11) {
        return phone.replace(/(\+\d{2})(\d{2})(\d{2})(\d{2})(\d{2})/, '$1 $2 $3 $4 $5');
    }
    if (phone.length === 8) {
        return phone.replace(/(\d{2})(\d{2})(\d{2})(\d{2})/, '$1 $2 $3 $4');
    }
    return phone; // Return the original phone number if it doesn't match the expected formats
};

export const getInitials = (name: string) => {
    const parts = name.split(' ');
    if (parts.length === 1) {
        return parts[0].charAt(0).toUpperCase();
    }
    return parts[0].charAt(0).toUpperCase() + parts[parts.length - 1].charAt(0).toUpperCase();
};
